import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Textbox } from "capitalrx-components-2.0/lib/forms";
import { Grid } from "capitalrx-components-2.0/lib/layout";

import { ThemedSubmitButton } from "@/App/components";

export const RequestEmailForm: FC = () => {
  const { t: translate } = useTranslation();
  return (
    <Grid>
      <Grid.Span columns={12}>
        <Textbox.Field
          testId="email"
          name="email"
          label={translate("FORGOT_PASSWORD.requestEmailForm.emailAddress")}
          placeholder={translate("FORGOT_PASSWORD.requestEmailForm.emailAddress")}
          required
        />
      </Grid.Span>

      <Grid.Span columns={12}>
        <Textbox.Field
          testId="member-id"
          name="memberId"
          label={translate("FORGOT_PASSWORD.requestEmailForm.memberId")}
          placeholder={translate("FORGOT_PASSWORD.requestEmailForm.memberId")}
          required
          instructions={translate("FORGOT_PASSWORD.requestEmailForm.memberIdCanBeFound")}
        />
      </Grid.Span>

      <Grid.Span columns={12}>
        <ThemedSubmitButton testId="next-step" icon="arrow-right" iconPosition="right">
          {translate("FORGOT_PASSWORD.requestEmailForm.nextStep")}
        </ThemedSubmitButton>
      </Grid.Span>
    </Grid>
  );
};
